<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div class="lyleft">
        <start-end ref="startEnd" timeModel="2,3"></start-end>
        <Button @click="chaxun" type="primary" size="small" class="chaxun"
          >立即查询</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="beforepic">
        <viewer
          v-if="row.beforeImgList != null && row.beforeImgList.length > 0"
        >
          <img
            v-for="(x, index) in row.beforeImgList"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="pic">
        <viewer v-if="row.afterImgList != null && row.afterImgList.length > 0">
          <img
            v-for="(x, index) in row.afterImgList"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="eventFlow(row, index)">查看进度</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Drawer v-model="openDrawer" title="事件处理历史进程" width="300">
      <Steps :current="0" direction="vertical">
        <Step
          icon="md-checkmark-circle-outline"
          v-for="(x, index) in steps"
          :key="index"
          :title="x.lable"
        >
          <p slot="content">经办：{{ x.createAccount }}</p>
          <p slot="content">备注：{{ x.remark == null ? "无" : x.remark }}</p>
          <p slot="content">{{ utils.time(x.createTime) }}</p>
        </Step>
      </Steps>
    </Drawer>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openDrawer: false,
      isAdd: false,
      axios: axios,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "事件编码",
          key: "no",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "当前进度",
          key: "eventStatus",
          render: (h, data) => {
            return h("div", this.$t("eventStatus." + data.row.status));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "项目名称",
          key: "groupName",
          minWidth: 100,
          maxWidth: 200,
        },
        
        {
          title: "事件内容",
          key: "content",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "事件来源",
          key: "source",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "业务事件",
          key: "businessType",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "上报图片",
          slot: "beforepic",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "处理图片",
          slot: "pic",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "处理反馈",
          key: "feedback",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "地址",
          key: "address",
          minWidth: 300,
          maxWidth: 350,
        },
        {
          title: "派单时间",
          minWidth: 130,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.assignTime, "yymmddhhmm"));
          },
        },
        {
          title: "预计完成时间",
          minWidth: 130,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.finishTime, "yymmddhhmm"));
          },
        },
        {
          title: "实际完成时间",
          minWidth: 130,
          maxWidth: 200,
          render: (h, data) => {
            return h(
              "div",
              this.utils.time(data.row.realFinishTime, "yymmddhhmm")
            );
          },
        },
        {
          title: "预计结案时间",
          minWidth: 130,
          maxWidth: 200,
          render: (h, data) => {
            return h(
              "div",
              this.utils.time(data.row.settleTime, "yymmddhhmm")
            );
          },
        },
        {
          title: "实际结案时间",
          minWidth: 130,
          maxWidth: 200,
          render: (h, data) => {
            return h(
              "div",
              this.utils.time(data.row.realSettleTime, "yymmddhhmm")
            );
          },
        },
        {
          title: "经办人",
          key: "userName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        id: "",
        feedBack: "",
        afterImgList: [],
      },
      ruleValidate: {
        feedBack: { required: true, message: "必填" },
      },
      pageNumber: 1,
      pageSize: 50,
      total: 0,
      steps: [],
      orderType: "0",
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      var params = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        groupId: "",
        businessType: "",
        source: "",
        keyWork: "",
        startTime: this.timeObj.start,
        endTime: this.timeObj.end,
        no: "",
      };
      axios({
        method: "post",
        url: axios.event + "/event/allList",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        this.tableData = data;
      });
    },
    eventFlow(v) {
      this.openDrawer = true;
      this.utils.loading(this, "加载中");
      var params = {
        eventId: v.id,
      };
      axios({
        method: "post",
        url: axios.event + "/eventFlow/list",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        //this.steps = data.reverse();
        this.steps = data;
      });
    },
    addUpdate(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.dm + "/carType/add",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.dm + "/carType/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    //删除公司
    shenqing(v) {},
    tuihui(v) {},
    //点击编辑按钮
    chuli(v) {
      this.item.id = v.id;
      this.openForm = true;
    },
    process() {
      this.utils.loading(this, "加载中");
      console.log(this.item);
      axios({
        method: "post",
        url: axios.event + "/event/process",
        data: this.item,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.openForm = false;
          this.getList();
        }
      });
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.timeObj = this.$refs.startEnd.getTimeObj();
      this.getList();
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/event/eventAllList.vue